module.exports = __webpack_public_path__ + "img/step7.903b9b39.png";